var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"outlined":"","clearable":"","items":_vm.columns,"menu-props":{ maxHeight: '200', zIndex: 13 },"label":"Dans la colonne"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []

export { render, staticRenderFns }